import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { IAppNotification } from '../../appBackend/useAppNotifications';
import BaseNotificationContent from './BaseNotificationContent';

export default function InvoiceBecomeOverdueIn7Days({ notification }:{notification: IAppNotification}): ReactElement {
  const { t } = useTranslation();
  const { invoiceNumber } = JSON.parse(notification.jsonPayload) as { invoiceNumber: string };
  return (
    <BaseNotificationContent
      title={t('InvoiceReminder')}
      description={t('YourCreditPeriodsEndsIn7Days')}
      linkPrefix={t('NoDotInvoice', { invoiceNumber })}
      linkText={t('ViewInvoice')}
      createdAt={notification.createdAt}
    />
  );
}
